export const ENGINEERING_CHANGE_DESCRIPTION_TEMPLATE = `## Change 1: [Short change name]

[State exactly what will change.]

### Purpose

[Explain why this change is needed.]

## Impact assessment

### Form, fit, and function

[Describe the impact or state "No impact."]

### Manufacturing

[Describe process, tooling, training, labor, or work-instruction impacts.]

### Quality and reliability

[Describe inspection, testing, acceptance, validation, or reliability impacts.]

### Supply chain

[Describe material or supplier impacts or state "No impact."]

### Field units

[Describe retrofit, recall, customer-notification, or monitoring needs, or state "No field action."]

## Disposition of existing material and work in process

[State what happens to existing inventory, work in process, and completed units.]`;

export const ENGINEERING_CHANGE_IMPLEMENTATION_PLAN_TEMPLATE = `## Implementation plan

[Describe how SGS rolls out this change: ECN issuance, recipient coordination, and verification. This is not sent on ECN PDFs.]

### Effective condition

[When each contract manufacturer must comply after receiving its ECN.]`;
